export const AiProcessTypeEnum = {
    GENERATE_CONTENT: 'generate_content',
    TRANSLATE_CONTENT: 'translate_content',
    UNIQUE_CONTENT: 'unique_content'
} as const;

export type AiProcessType = typeof AiProcessTypeEnum[keyof typeof AiProcessTypeEnum];
